import config from "../../config";
import axios from "axios";
import { setShopifyFavorites } from "./shopifyAC"
import underscore from "underscore";
import {getItemsFromBC} from "./boostCommerceAC";
import {Multipass} from "multipass-js";
import {
    authCheck,
    canSeeFirstLook,
    deleteCookie,
    getCookie,
    setCookie,
    isBetweenDates,
} from "../common/utils";
import appErrorLogger from "../common/DataDogErrorLog";
import { getSelectedMembershipPlan, mapTransactions } from "../MyAccount/Wallet/helpers"
import _ from "underscore";
import {sendDeclinedProvideInfo, getAddresses} from "./selfCheckInAC";
import { setSelectedContribution } from "./rewardsPlus"

const setAxiosInstance = () => {
    const auth_token = getCookie('auth_token');
    const is_b2b = getCookie('is_b2b');
    return axios.create({
        baseURL: `${config.host_rebag_api}/v6/my-account`,
        timeout: is_b2b ? 120000 : 45000,
        headers: {'Authorization': auth_token}
    });
};

const getSkuFollowingList = () => {
    return (dispatch, _) => {
        setAxiosInstance().get("/saved-skus/")
            .then((response) => {
                dispatch({
                    type: 'SKU_LIST',
                    saved_sku_list: response.data
                })
            })
            .catch((error) => appErrorLogger('Get SKU Following List', error))
    }
};

const addToSkuFollowingList = (pv) => {
    return (dispatch, _) => {
        setAxiosInstance().post("/saved-skus/",
            {
                sku_id: pv.id
            })
            .then((response) => {
                dispatch(getSkuFollowingList())
            })
            .catch((error) => appErrorLogger('Add SKU To Following List', error))
    }
};

const removeFromSkuFollowingList = (pv) => {
    return (dispatch, _) => {
        setAxiosInstance().delete(`/saved-skus/${pv.id}/`)
            .then((response) => {
                dispatch(getSkuFollowingList())
            })
            .catch((error) => appErrorLogger('Remove SKU From Following List', error))
    }
};

const getPaymentMethods = (callback) => {
    setAxiosInstance().get("/payments/profiles/")
        .then((response) => {
            if (callback) {
                callback(response.data);
            }
        })
        .catch((error) => appErrorLogger('Get Payment Methods', error))
};

const updateMarketingFlags = (payload) => {
    return (dispatch, _) => {
        dispatch({type: "SHOW_SPINNER"});
        setAxiosInstance().put("/subscriptions/", payload)
            .then((response) => {
                dispatch(setUserProfile());
            })
            .catch((e) => {
                appErrorLogger('My Account addGiftCardsToCheckout', e)
            })
            .then(() => {
                dispatch({type: "HIDE_SPINNER"});
            })
    }
}

const updateUserProfile = (person, callback, message) => {
    return (dispatch, _) => {
        dispatch({type: "SHOW_SPINNER"});
        setAxiosInstance().put("/", person)
            .then((response) => {
                dispatch(setUserProfile());
                return response;
            })
            .then((response) => {
                callback(message || response.data);
            })
            .catch((error) => appErrorLogger('Update User Profile', error))
            .then(() => {
                dispatch({type: "HIDE_SPINNER"});
            })
    }
};

const updateUserPassword = (password_data, callback) => {
    return (dispatch, _) => {
        dispatch({type: "SHOW_SPINNER"});
        setAxiosInstance().post("/password/change/", password_data)
            .then((response) => {
                if(response.data.detail){
                    callback(response.data.detail);
                } else {
                    callback(response.data);
                }
            })
            .catch(function (error) {
                const server_error = error.response.data;
                if(server_error.detail[0]){
                    callback(server_error.detail[0]);
                }
            })
            .then(() => {
                dispatch({type: "HIDE_SPINNER"});
            })
    }
};

const setUserProfile = () => {
    return (dispatch, getState) => {
        return new Promise (async (resolve) => {
            if(authCheck()) {
                setAxiosInstance().get("/")
                    .then((response) => {
                        const user_profile = response.data;
                        //@TODO remove after we are convinced cookies work properly
                        const localStorage_user_profile = JSON.parse(localStorage.getItem('user_profile'));
                        if (localStorage_user_profile) {
                            user_profile.walletCashOut = localStorage_user_profile.walletCashOut;
                        }
                        localStorage.setItem('user_profile', JSON.stringify(user_profile));
                        setCookie("can_see_first_look", canSeeFirstLook(user_profile));
                        setCookie("user_hash", user_profile.user_hash);
                        if (!getCookie('TAkkSnIQO4M8g5')) {
                            setCookie('TAkkSnIQO4M8g5', 'b0dk3LX0zIcp40', 365);
                        }
                        if (user_profile.show_new_arrivals_pop_up) {
                            setCookie("show_new_arrivals_pop_up", "1", 2);
                        }
                        const wholesale_menu = _.find(config.header_menu_items, (menu_item) => {
                            return menu_item.key === 'wholesale';
                        })
                        const is_wholesale_active = user_profile.is_b2b && isBetweenDates(wholesale_menu.available_between[0], wholesale_menu.available_between[1])
                        if(is_wholesale_active) {
                            setCookie("is_wholesale_active", "1");
                        } else {
                            deleteCookie("is_wholesale_active");
                        }

                        dispatch({
                            type: 'SET_USER_PROFILE',
                            user: user_profile
                        });
                        dispatch({
                            type: 'SET_PROFILE_FAVORITES',
                            payload: user_profile.favorites
                        });
                        resolve(user_profile);
                    })
                    .catch((error) => {
                        resolve(null);
                        appErrorLogger('My Account setUserProfile', error)
                    });
            } else {
                resolve(getState().myAccountReducer.user_profile);
            }
        })
    }
}

const getPurchases = (purchase_number, togglePurchaseDetails, paginated_url = null) => {
    return (dispatch, getState) => {
        dispatch({type: "SHOW_SPINNER"});
        const next_url = paginated_url ? paginated_url.replace(`${config.host_rebag_api}/v6/my-account`, '') : "/purchases/";
        setAxiosInstance().get(next_url)
            .then((response) => {
                dispatch({
                    type: "SET_PREVIOUS_PURCHASES",
                    prev_purchases: response.data.orders,
                    next_purchases_page: response.data.next,
                    previous_purchases_page: response.data.previous,
                });

                if (purchase_number) {
                    const purchaseFromURL = _.find(response.data.orders, (purchase) => {
                        return purchase.number.toString() === purchase_number;
                    })
                    if (purchaseFromURL) {
                        togglePurchaseDetails(purchaseFromURL);
                    }
                }
            })
            .catch((error) => appErrorLogger('Get Purchases', error))
            .then(() => {
                dispatch({type: "HIDE_SPINNER"});
            })
    }
}

const getSpecificPurchase = (purchase_id, togglePurchaseDetails) => {
    return (dispatch, getState) => {
        dispatch({type: "SHOW_SPINNER"});
        setAxiosInstance().get(`/purchases/${purchase_id}/`)
            .then((response) => {
                dispatch({
                    type: "SET_SPECIFIC_PREVIOUS_PURCHASE",
                    payload: response.data,
                });

                if (togglePurchaseDetails) {
                    togglePurchaseDetails(response.data);
                }
            })
            .catch((error) => appErrorLogger('Get Purchases', error))
            .then(() => {
                dispatch({type: "HIDE_SPINNER"});
            })
    }
}

const getSubmissions = (paginated_url = null) => {
    return (dispatch, getState) => {
        dispatch({type: "SHOW_SPINNER"});
        const next_url = paginated_url ? paginated_url.replace(`${config.host_rebag_api}/v6/my-account`, '') : "/ticket/";
        setAxiosInstance().get(next_url)
            .then((response) => {
                dispatch({
                    type: "SET_SUBMISSIONS",
                    payload: response.data.tickets,
                    prev_ticket_page: response.data.previous,
                    next_ticket_page: response.data.next,
                });
                dispatch({
                    type: "SET_SUBMISSIONS_PROVIDE_INFO",
                    payload: null,
                });
                dispatch({
                    type: "SET_SUBMISSIONS_PROVIDE_INFO_ERROR",
                    payload: null,
                });
                dispatch({
                    type: "SET_SUBMISSION_ORDER_DETAILED",
                    payload: null,
                });
                dispatch({
                    type: "SET_SUBMISSION_ORDER_DETAILED_ERROR",
                    payload: null,
                });
            })
            .catch((error) => {
                console.log(error);
            })
            .then(() => {
                dispatch({type: "HIDE_SPINNER"});
            });
    }
}

const getSubmissionOrderDetails = (zendesk_ticket) => {
    return (dispatch, getState) => {
        dispatch({type: "SHOW_SUBMISSION_SPINNER"});
        setAxiosInstance().get(`/order/${zendesk_ticket}/`)
            .then((response) => {
                dispatch({
                    type: "SET_SUBMISSION_ORDER_DETAILED",
                    payload: response.data.order,
                });
            })
            .catch((error) => {
                dispatch({
                    type: "SET_SUBMISSION_ORDER_DETAILED_ERROR",
                    payload: error.response.data.detail,
                });
            })
            .then(() => {
                dispatch({type: "HIDE_SUBMISSION_SPINNER"});
            });
    }
}

const getSubmissionsProvideInfoPhotos = (evaluation_id) => {
    return (dispatch, getState) => {
        setAxiosInstance().get(`/nmi/photos/${evaluation_id}/`)
            .then((response) => {
                dispatch({
                    type: "SET_SUBMISSIONS_PROVIDE_INFO_PHOTOS",
                    payload: response.data,
                });
            })
            .catch((error) => {
                console.log(error);
            })
    }
}

const getSubmissionsProvideInfo = (evaluation_id) => {
    return (dispatch, getState) => {
        dispatch({type: "SHOW_SUBMISSION_SPINNER"});
        dispatch({type: "RESET_EVALUATION_PHOTO_SET"});
        dispatch({
            type: "SET_SUBMISSIONS_PROVIDE_INFO",
            payload: null,
        });
        dispatch({
            type: "SET_SUBMISSIONS_PROVIDE_INFO_ERROR",
            payload: null,
        });
        dispatch({
            type: "SET_SUBMISSIONS_PROVIDE_INFO_PHOTOS",
            payload: null,
        });
        setAxiosInstance().get(`/nmi/${evaluation_id}/?version=1/`)
            .then((response) => {
                dispatch({
                    type: "SET_SUBMISSIONS_PROVIDE_INFO",
                    payload: response.data,
                });
            })
            .catch((error) => {
                dispatch({
                    type: "SET_SUBMISSIONS_PROVIDE_INFO_ERROR",
                    payload: error.response.data.detail,
                });
            })
            .then(() => {
                dispatch({type: "HIDE_SUBMISSION_SPINNER"});
            });
    }
}

const getSubmissionsProvideInfoHermesLeather = () => {
    return (dispatch, getState) => {
        setAxiosInstance().get(`/hermes_leather_types/`)
            .then((response) => {
                dispatch({
                    type: "SET_SUBMISSIONS_PROVIDE_INFO_HERMES_LEATHER",
                    payload: response.data.leather_types,
                });
            })
            .catch((error) => {
                console.log(error);
            })
            .then(() => {

            });
    }
}

const getSubmissionsProvideInfoHermesSizes = () => {
    return (dispatch, getState) => {
        setAxiosInstance().get(`/hermes_sizes_cm/`)
            .then((response) => {
                dispatch({
                    type: "SET_SUBMISSIONS_PROVIDE_INFO_HERMES_SIZES",
                    payload: response.data.sizes_cm,
                });
            })
            .catch((error) => {
                console.log(error);
            })
            .then(() => {

            });
    }
}

const getSubmissionsDetailed = (zendesk_ticket) => {
    return (dispatch, getState) => {
        dispatch({type: "SHOW_SUBMISSION_SPINNER"});
        setAxiosInstance().get(`/quote/${zendesk_ticket}/`)
            .then((response) => {
                dispatch({
                    type: "SET_SUBMISSIONS_DETAILED",
                    payload: response.data.quotes,
                    payloadId: zendesk_ticket,
                });
                dispatch({type: "HIDE_SUBMISSION_SPINNER"});
            })
            .catch((error) => {
                if (error.response) {
                    dispatch({
                        type: "SET_SUBMISSIONS_DETAILED",
                        payload: error.response.data.detail,
                        payloadId: zendesk_ticket,
                    });
                } else {
                    dispatch({
                        type: "SET_SUBMISSIONS_DETAILED",
                        payload: 'An error has occurred. Please try again later.',
                        payloadId: zendesk_ticket,
                    });
                }
                dispatch({type: "HIDE_SUBMISSION_SPINNER"});
            })
    }
}

const getTradeIns = () => {
    return (dispatch, _) => {
        dispatch({type: "SHOW_SPINNER"});
        setAxiosInstance().get("/trade-in/")
            .then((response) => {
                dispatch(setTradeIns(response.data.tradein));
            })
            .catch((error) => appErrorLogger('Get Trades', error))
            .then(() => {
                dispatch({type: "HIDE_SPINNER"});
            });
    }
}

const setTradeIns = (trade_ins) => {
    return (dispatch, _) => {
        dispatch({
            type: "SET_TRADE_INS",
            trade_ins: trade_ins
        });
    }
}

const getTradeInDetails = (trade_in_id, history) => {
    return (dispatch, _) => {
        dispatch({type: "SHOW_SPINNER"});
        setAxiosInstance().get(`/trade-in/${trade_in_id}/`)
            .then((response) => {
                if (response.data.tradein) {
                    dispatch({
                        type: "SET_TRADE_IN_DETAILS",
                        trade_in_details: response.data.tradein
                    });
                    history.push({
                        search: `${window.location.search}${window.location.search ? "&" : "?"}trade_in_id=${trade_in_id}`
                    });
                }
            })
            .catch((error) => appErrorLogger('Get Trade Details', error))
            .then(() => {
                dispatch({type: "HIDE_SPINNER"});
            });
    }
}

const payAndFinalizeTweak = (so_id) => {
    return (dispatch, _) => {
        dispatch({type: "SHOW_SPINNER"});
        setAxiosInstance().post(`/trade-in/pay/`,
            {
                so_id: so_id
            })
            .then((response) => {
                const {checkout_web_url} = response.data;
                if(checkout_web_url){
                    deleteCookie('is_checkout_finished');
                    setCookie('is_custom_cart', 1);
                    setCookie('trade_in_tweak_checkout', 1, 1);

                    const multipass = new Multipass(config.storefront_api.secret_key);
                    const customerData = {
                        email: getCookie('auth_email'),
                        user: getCookie('auth_token'),
                    };

                    const url = multipass.withCustomerData(customerData)
                        .withDomain(config.storefront_api.domain)
                        .withRedirect(checkout_web_url)
                        .url();

                    window.location.href = url;
                }
            })
            .catch((error) => appErrorLogger('Pay And Finalize Tweak', error))
            .then(() => {
                dispatch({type: "HIDE_SPINNER"});
            });
    }
};

const finalizeTweak = (so_id, trade_in_key, is_in_details) => {
    return (dispatch, getState) => {
        const trade_ins = getState().myAccountReducer.trade_ins;
        dispatch({type: "SHOW_SPINNER"});

        setAxiosInstance().post(`/trade-in/accept-and-finalize/`,
            {
                so_id: so_id
            })
            .then((response) => {
                if (response.data) {
                    let processed_trade_ins = [...trade_ins];
                    processed_trade_ins[trade_in_key].pay_cta = null;
                    dispatch(setTradeIns(processed_trade_ins));
                    if (is_in_details) {
                        dispatch({
                            type: "SET_TRADE_IN_DETAILS",
                            trade_in_details: processed_trade_ins[trade_in_key]
                        });
                    }
                }
            })
            .catch((error) => appErrorLogger('Finalize Tweak', error))
            .then(() => {
                dispatch({type: "HIDE_SPINNER"});
            });
    }
};

const updateTradeInTweak = (trade_in_key, submission_key, user_response, is_in_details) => {
    return (dispatch, getState) => {
        const trade_ins = getState().myAccountReducer.trade_ins;
        const order_item_id = trade_ins[trade_in_key].selling.submissions[submission_key].order_item_id;
        dispatch({type: "SHOW_SPINNER"});

        setAxiosInstance().put(`/trade-in/client-response/${order_item_id}/`,
            {
                client_response: user_response
            })
            .then((response) => {
                if (response.data.trade_in) {
                    let processed_trade_ins = [...trade_ins];
                    processed_trade_ins[trade_in_key] = response.data.trade_in;
                    dispatch(setTradeIns(processed_trade_ins));
                    if (is_in_details) {
                        dispatch({
                            type: "SET_TRADE_IN_DETAILS",
                            trade_in_details: response.data.trade_in
                        })
                    }
                }
            })
            .catch((error) => appErrorLogger('Update Trade Tweak', error))
            .then(() => {
                dispatch({type: "HIDE_SPINNER"});
            })
    }
};

const resetTradeInDetails = (history) => {
    return (dispatch, _) => {
        let urlParams = new URLSearchParams(window.location.search);

        dispatch({
            type: "RESET_TRADE_IN_DETAILS"
        });

        urlParams.delete('trade_in_id');
        history.push({
            search: urlParams.toString()
        });
    }
}

const getMyAccountFavorites = (params) => {
    return (dispatch, _) => {
        const shop_prefix = "gid://shopify/Product/";
        setAxiosInstance().get(`/favorites-p/`, {params: params})
            .then((response) => {
                const {results, count} = response.data;
                dispatch({
                    type: 'GET_SHOPIFY_FAVORITES',
                    favorites_count: count
                });
                const product_ids = underscore.map(results, (product) => {
                    return btoa(shop_prefix + product.product_id);
                })
                dispatch(setShopifyFavorites(product_ids));
            })
            .catch((error) => appErrorLogger('Get MyAccount Favorites', error))
    }
};

const getSavedSearches = () => {
    return (dispatch, _) => {
        setAxiosInstance().get(`/saved-search/`)
            .then((response) => {
                dispatch({
                    type: "SAVED_SEARCHES",
                    saved_searches: response.data
                })
            })
            .catch((error) => appErrorLogger('Get Saved Searches', error))
    }
}

const addSavedSearch = (payload) => {
    return (dispatch) => {
        setAxiosInstance().post(`/saved-search/`, { ...payload })
          .then((response) => {
              dispatch({
                  type: "ADD_SAVED_SEARCH",
                  payload: response.data
              })
          })
          .catch((error) => appErrorLogger('Add Saved Search', error))
    }
}

const deleteSavedSearch = (data) => {
    return (dispatch, _) => {
        setAxiosInstance().delete(`/saved-search/${data.id}/`)
            .then((response) => {
                dispatch(getSavedSearches());
            })
            .catch((error) => appErrorLogger('Delete Saved Searches', error))
    }
}

const updateSavedSearch = (data) => {
    return (dispatch, _) => {
        dispatch({type: "SHOW_SPINNER"});
        setAxiosInstance().put(`/saved-search/${data.id}/`, data)
            .then((response) => {
                dispatch(getSavedSearches());
                dispatch(getItemsFromBC(response.data));
            })
            .catch((error) => appErrorLogger('Update Saved Searches', error))
            .then(() => dispatch({type: "HIDE_SPINNER"}))
    }
}

const getTradeInCartId = () => {
    return getCookie('shopify_cart_id');
}

const getGiftCardsTotal = () => {
    return (dispatch, _) => {
        return setAxiosInstance().get(`${config.host_rebag_api}/v6/get-gift-card-total-details/`)
            .then((response) => {
                dispatch({
                    type: 'SET_GIFT_TOTAL',
                    user_gift_card_total: response.data.amount,
                    user_gift_card_gfy_total: response.data.gfy_amount
                })
            })
            .catch(function (error) {
                appErrorLogger('My Account getGiftCardsTotal', error)
            });
    }
}

const getCreditSummary = () => {
    return (dispatch, _) => {
        return setAxiosInstance().get("/site-credit/")
            .then((response) => {
                dispatch({
                    type: 'SET_CREDIT_LIST',
                    credit_summary: response.data
                })
            })
            .catch(function (error) {
                appErrorLogger('My Account getCreditSummary', error)
            });
    }
}

const submitShareFavorites = (data) => {
    return (dispatch, _) => {
        dispatch({type: "SHOW_MODAL_SPINNER"});
        setAxiosInstance().post(`${config.host_rebag_api}/v6/favorites/share/`, data, { withCredentials: true })
            .then((response) => {
                dispatch({
                    type: "HIDE_MODAL_SPINNER_WITH_TYPE",
                    was_call_successful: true
                });
            })
            .catch(function (error) {
                appErrorLogger('My Account submitShareFavorites', error)
                dispatch({
                    type: "HIDE_MODAL_SPINNER_WITH_TYPE",
                    was_call_successful: false
                });
            });
    }
}

const deletePaymentAddressOrAccount = (payment_address_or_account_id, callback) => {
    return (dispatch, _) => {
        setAxiosInstance().delete(`/payments/profile/${payment_address_or_account_id}/`)
            .then((response) => {
                getPaymentMethods(callback);
            })
            .catch(function (error) {
                appErrorLogger('My Account deletePaymentAddressOrAccount', error)
                dispatch(setWalletError(error.response.data.detail));
            });
    }
};

const deleteAddress = (address_id, callback) => {
    return (dispatch, _) => {
        setAxiosInstance().delete(`/address/${address_id}/`)
            .then((response) => {
                getAddresses(callback);
            })
            .catch(function (error) {
                if (error?.response?.data) {
                    callback(error.response.data.detail);
                } else {
                    callback('Something went wrong, please try again!');
                }
                appErrorLogger('My Account: deleteAddress', error)
            });
    }
};

const editAddress = (data, callback, address_id) => {
    setAxiosInstance().put(`/address/${address_id}/`, data)
        .then((response) => {
            callback(response);
        })
        .catch(function (error) {
            const server_error = error.response.data;
            if(server_error.detail){
                callback(error.response.data);
            }
        });
};

const sendCouponEmailData = (email, callback) => {
    return (dispatch, _) => {
        dispatch({type: "SHOW_SPINNER"});
        setAxiosInstance().post(`${config.host_rebag_api}/trendlee/subscribe/`, {email})
            .then((response) => {
                try {
                    window.userEmail = email;
                    window.dataLayer.push({
                        'event': 'NLOfferSubscribe',
                    });
                } catch (err) {
                    appErrorLogger('NLOfferSubscribe', err)
                }
                callback(response);
            })
            .catch(function (error) {
                callback(error);
                appErrorLogger('Redeem Gift Card', error);
            })
            .then(() => dispatch({type: "HIDE_SPINNER"}))
    }
}

const sendSmsValidationCode = (data) => {
    return (dispatch, getState) => {
        setAxiosInstance()
            .post('/phone_validation/', data)
            .then((response) => {
                dispatch({
                    type: "SET_SMS_VALIDATION_CODE",
                })
            })
            .catch((error) => {
                if(error.response && error.response.status === 400){
                    dispatch({
                        type: "SET_SMS_VALIDATION_CODE_ERROR",
                        detail: error.response.data.detail
                    })
                }
                if(error.response && error.response.status === 403){
                    dispatch({
                        type: "SET_SMS_VALIDATION_CODE",
                    })
                }
                appErrorLogger('Send SMS code validation', error);
            })
    }
}

const checkSmsValidationCode = (data) => {
    return (dispatch, getState) => {
        dispatch({
            type: "SET_SMS_CHECK_CODE",
            sms_code_state: 2,
            sms_code_state_message: ''
        })

        setTimeout(() => {
            setAxiosInstance()
                .post('/phone_validation/', data)
                .then((response) => {
                    dispatch({
                        type: "SET_SMS_CHECK_CODE",
                        sms_code_state: 3,
                        sms_code_state_message: ''
                    })
                })
                .catch((error) => {
                    dispatch({
                        type: "SET_SMS_CHECK_CODE",
                        sms_code_state: 1,
                        sms_code_state_message: error.response.data.detail
                    })
                })
        }, 3000);
    }
}

const dismissSmsCheckResultModal = () => {
    return (dispatch, getState) => {
        dispatch({
            type: "SET_SMS_CHECK_CODE",
            sms_code_state: 0,
            sms_code_state_message: ''
        })
    }
}

const getReturnValues = (history, purchase_name, purchase_number, selected_reasons, errorCallback) => {
    return (dispatch, getState) => {
        dispatch({type: "SHOW_SPINNER"});
        const purchase_id = purchase_name.substring(1);
        const purchase_items_list = underscore.pluck(selected_reasons, 'item');
        const data = new FormData()
        data.set('item_list', JSON.stringify(purchase_items_list));

        setAxiosInstance()
            .post(`/${purchase_id}/calculate-return/`, data)
            .then((response) => {
                const location = {
                    pathname: `/purchases/refund/${purchase_number}`,
                    state: {
                        selected_reasons: selected_reasons,
                        refunds: response.data,
                        items_list: purchase_items_list
                    },
                };
                history.push(location);
                dispatch({type: "HIDE_SPINNER"});
            })
            .catch(() => {
                errorCallback("Your request for return could not be completed. Please contact customer support <a href='https://support.rebag.com/hc/en-us/articles/360038451531-How-do-I-contact-Rebag-' rel='nofollow noopener' target='_blank'>here</a>.");
                dispatch({type: "HIDE_SPINNER"});
            })
    }
}

const doReturn = (history, purchase_name, purchase_number, selected_reasons, errorCallback) => {
    const purchase_id = purchase_name.substring(1);
    const purchase_items_list = underscore.pluck(selected_reasons, 'item');
    const data = new FormData();
    data.set('items', JSON.stringify(selected_reasons));

    return (dispatch, getState) => {
        dispatch({type: "SHOW_SPINNER"});
        setAxiosInstance()
            .post(`/${purchase_id}/return/`, data)
            .then((response) => {
                const location = {
                    pathname: `/purchases/refund-thank-you/${purchase_number}`,
                    state: {
                        data: response.data,
                        items_list: purchase_items_list
                    },
                };
                history.push(location);
            })
            .catch(() => {
                errorCallback("Your request for return could not be completed. Please contact customer support <a href='https://support.rebag.com/hc/en-us/articles/360038451531-How-do-I-contact-Rebag-' rel='nofollow noopener' target='_blank'>here</a>.");
            })
            .then(() => {
                dispatch({type: "HIDE_SPINNER"});
            })
    }
}

const setToggleCancelOrderModal = (show_hide, order_name, error = '') => {
    return(dispatch, _) => {
        dispatch({
            type: 'TOGGLE_CANCEL_ORDER_MODAL',
            toggle_cancel_order_modal: show_hide,
            cancel_order_name: order_name,
            cancel_order_error: error
        })
    }
}

const cancelOrder = (purchase_name) => {
    return (dispatch, _) => {
        const data = new FormData();
        data.set('order', purchase_name);

        dispatch({type: "SHOW_SPINNER"});
        setAxiosInstance()
            .post(`/cancel-order/`, data)
            .then(() => {
                dispatch(getPurchases());
            })
            .then((response) => {
                dispatch(setToggleCancelOrderModal(false, null, null))
            })
            .catch((error) => {
                const error_message = 'Your request could not be completed. Please contact customer support <a class="cancel-order-modal__link" href=\'https://support.rebag.com/hc/en-us/articles/360038451531-How-do-I-contact-Rebag-\' rel=\'nofollow noopener\' target=\'_blank\'>here</a>.'
                dispatch(setToggleCancelOrderModal(true, purchase_name, error_message))
                appErrorLogger('Cancel order', error);
            })
            .then(() => {
                dispatch({type: "HIDE_SPINNER"});
            })
    }
}

const getWalletDetails = () => {
    return (dispatch) => {
        return new Promise(resolve => {
            setAxiosInstance().get("/wallet/")
              .then((response) => {
                  dispatch(setWalletDetails(response.data));
                  if (response.data.details && response.data.details.rewards_credit) {
                      dispatch({
                          type: 'SET_MEMBERSHIP_PERIOD',
                          payload: response.data.details.rewards_credit.membership_plan.rewards_billing_cycle
                      })
                      dispatch(setSelectedContribution(config.subscriptions.oneOff[0]));
                      if (response.data.details.rewards_credit.membership_plan.amount) {
                          dispatch({
                              type: 'SET_MEMBERSHIP_SELECTED_SUBSCRIPTION',
                              payload: getSelectedMembershipPlan(response.data.details.rewards_credit.membership_plan.amount, response.data.details.rewards_credit.membership_plan.rewards_billing_cycle)
                          })
                      } else {
                          dispatch({
                              type: 'SET_MEMBERSHIP_SELECTED_SUBSCRIPTION',
                              payload: config.subscriptions.monthly[0]
                          })
                      }

                  }
                  resolve();
              })
              .catch((error) => {
                  appErrorLogger('Get Wallet Details', error);
                  resolve();
              })
        })
    }
}

const setWalletDetails = (walletDetails) => {
    return {
        type: 'SET_WALLET_DETAILS',
        payload: walletDetails,
    }
}

const setWalletPaymentMethods = (paymentMethods) => {
    return {
        type: 'SET_PAYMENT_METHODS',
        payload: paymentMethods,
    }
}

const updateAccount = (account) => {
    return (dispatch) => {
        setAxiosInstance().put(`/payments/profile/${account.id}/`, {is_preferred_for_wallet: 'true', is_preferred: 'true'})
            .then((response) => {
                if (account.provider_type === 'ach') {
                    dispatch(setFavoriteBankAccount(account));
                } else {
                    dispatch(setFavoriteCheckAddress(account));
                }
                getPaymentMethods((paymentMethods) => dispatch(setWalletPaymentMethods(paymentMethods)));
            })
            .catch((error) => appErrorLogger('My Account update account', error))
    }
}

const setFavoriteBankAccount = () => {
    return (dispatch, getState) => {
        //if no favorite account comes from api, we will set 1 by default
        const paymentMethods = {...getState().myAccountReducer.paymentMethods};
        const favoriteAcc = paymentMethods.ach.filter(ach => ach.is_preferred_for_wallet)[0];
        if (favoriteAcc) {
            dispatch({
                type: 'SET_FAVORITE_BANK_ACCOUNT',
                payload: favoriteAcc,
            })
        } else {
            paymentMethods.ach[0].is_preferred_for_wallet = true;
            dispatch(setWalletPaymentMethods(paymentMethods));
            dispatch({
                type: 'SET_FAVORITE_BANK_ACCOUNT',
                payload: paymentMethods.ach[0],
            })

        }
    }
}

const setFavoriteCheckAddress = () => {
    return (dispatch, getState) => {
        //if no favorite address comes from api, we will set 1 by default
        const paymentMethods = {...getState().myAccountReducer.paymentMethods};
        const favoriteAddress = paymentMethods.check.filter(check => check.is_preferred_for_wallet)[0];
        if (favoriteAddress) {
            dispatch({
                type: 'SET_FAVORITE_CHECK_ADDRESS',
                payload: favoriteAddress,
            })
        } else {
            paymentMethods.check[0].is_preferred_for_wallet = true;
            dispatch(setWalletPaymentMethods(paymentMethods));
            dispatch({
                type: 'SET_FAVORITE_CHECK_ADDRESS',
                payload: paymentMethods.check[0],
            })
        }
    }
}

const getTransactionHistory = (type, callback) => {
    return (dispatch, _) => {
        setAxiosInstance().get(`/wallet/${type}/history/`)
            .then((response) => {
                if (response.data && response.data.length) {
                    dispatch({
                        type: `SET_${type.toUpperCase()}_TRANSACTION_HISTORY`,
                        payload: mapTransactions(response.data),
                    })
                }
                callback();
            })
            .catch((error) => appErrorLogger(`Get ${type.toUpperCase()} Transaction History`, error))
    }
}

const getPointsTransactionHistory = (callback) => {
    return (dispatch, _) => {
        dispatch(getTransactionHistory('points', callback))
    }
}

const getCashTransactionHistory = (callback) => {
    return (dispatch, _) => {
        dispatch(getTransactionHistory('cash', callback))
    }
}

const getCreditTransactionHistory = (callback) => {
    return (dispatch, _) => {
        dispatch(getTransactionHistory('credit', callback))
    }
}

const walletCashOut = (payment_profile_id, amount, callbackAction, setShow2FAModal) => {
    return (dispatch) => {
        dispatch({type: "SHOW_SPINNER"});
        setAxiosInstance().post('/wallet/cash-out/', {payment_profile_id, amount})
          .then((response) => {
              dispatch({type: "HIDE_SPINNER"});
              callbackAction(response.data);
              dispatch(getWalletDetails());
          })
          .catch(function (error) {
              dispatch({type: "HIDE_SPINNER"});
              appErrorLogger("Wallet Cash Out", error)

              if (!error.response) {
                  return false;
              }

              if(error.response && error.response.status === 412) {
                  setTimeout(function(){
                      dispatch(setWallet2FAError(null));
                      dispatch(setWallet2FAScreenType(3));
                      setShow2FAModal(true);
                  }, 1500);
              } else {
                  dispatch(setWalletError(error?.response?.data?.detail));
              }
          });
    }
}

const setWalletError = (errorMessage) => {
    return {
        type: 'SET_WALLET_ERROR',
        payload: errorMessage,
    }
}

const getWallet2FAToken = (screenType) => {
    return (dispatch, getState) => {
        if (getState().myAccountReducer.wallet2FAData.errorMessage) {
            dispatch(setWallet2FAError(null));
        }

        setAxiosInstance().post(`${config.host_rebag_api}/v6/wallet/2fa/get-code/`)
            .then((response) => {
                dispatch(setWallet2FAToken(response.data?.token));
                if (getState().myAccountReducer.wallet2FAData.blockedFor) {
                    dispatch(setWallet2FABlockedFor(""));
                }
                dispatch(setWallet2FAScreenType(screenType));
            })
            .catch((error) => {
                appErrorLogger("Get Wallet 2FA Code", error)

                if (!error.response) {
                    return false;
                }

                const {code} = error.response.data;
                switch(code){
                    case "2fa_blocked":
                        dispatch(setWallet2FAScreenType(7));
                        dispatch(setWallet2FAVerified(false));
                        dispatch(setWallet2FABlockedFor(error.response.data.blocked_for));
                        return;
                    default:
                        dispatch(setWallet2FAError(error.response.data.detail));
                        dispatch(setWallet2FAScreenType(screenType));
                        return;
                }
            })
    }
}

const sendWallet2FAData = (code) => {
    return (dispatch, getState) => {
        const wallet2FAData = getState().myAccountReducer.wallet2FAData;
        dispatch(setWallet2FAError(null));
        dispatch(setWallet2FAScreenType(4));

        const data = {
            "code_token": wallet2FAData.token,
            "code": code
        }

        setAxiosInstance().post(`${config.host_rebag_api}/v6/wallet/2fa/auth/`, data)
            .then((response) => {
                dispatch(setWallet2FAVerified(true));
                dispatch(setWallet2FABlockedFor(""));
                dispatch(setWallet2FAScreenType(5));
            })
            .catch((error) => {
                appErrorLogger("Wallet 2FA Auth", error)

                if (!error.response) {
                    return false;
                }

                const {code} = error.response.data;
                switch(code){
                    case "max_retries_limit_exceeded":
                        dispatch(setWallet2FAScreenType(7));
                        dispatch(setWallet2FAVerified(false));
                        dispatch(setUserProfile());
                        return;
                    case "invalid_token":
                    case "authentication_failed":
                        dispatch(setWallet2FAError(error.response.data.message));
                        dispatch(setWallet2FAScreenType(2));
                        return;
                    case "permission_denied":
                        setTimeout(function(){
                            dispatch(getWallet2FAToken(3));
                        }, 1500);
                        return;
                    default:
                        dispatch(setWallet2FAError("Cannot authenticate at this time, please try again later"));
                        dispatch(setWallet2FAScreenType(2));
                        return;
                }
            })
    }
}

const setWallet2FAToken = (wallet2FAToken) => {
    return {
        type: 'SET_WALLET_2FA_TOKEN',
        payload: wallet2FAToken,
    }
}

const setWallet2FAScreenType = (screenType) => {
    return {
        type: 'SET_WALLET_2FA_SCREEN_TYPE',
        payload: screenType,
    }
}

const setWallet2FAVerified = (isVerified) => {
    return {
        type: 'SET_WALLET_2FA_VERIFIED',
        payload: isVerified,
    }
}

const setWallet2FAError = (errorMessage) => {
    return {
        type: 'SET_WALLET_2FA_ERROR',
        payload: errorMessage,
    }
}

const setWallet2FABlockedFor = (blockedFor) => {
    return {
        type: 'SET_WALLET_2FA_BLOCKED_FOR',
        payload: blockedFor,
    }
}

const setWalletAmountToCashOut = (amount) => {
    return {
        type: 'SET_WALLET_AMOUNT_TO_CASH',
        payload: amount,
    }
}

const setAmountToCashModal = (value) => {
    return {
        type: 'SET_WALLET_AMOUNT_TO_CASH_MODAL',
        payload: value,
    }
}

const setAmountToCashLinkPath = (linkPath) => {
    return {
        type: 'SET_WALLET_AMOUNT_TO_CASH_LINK_PATH',
        payload: linkPath
    }
}

const setEvaluationPhotoSet = (photo_uuid) => {
    return {
        type: 'SET_EVALUATION_PHOTO_SET',
        payload: photo_uuid,
    }
}

const sendFinalProvideInfoEvaluation = (evaluation_id, zendesk_ticket, nextNMIEvaluation, submissionProvideInfoFields, provideInfoData, history) => {
    return (dispatch, getState) => {
        let payloadArray = [];
        let refusedReason = "";
        const {evaluationphoto_set} = getState().myAccountReducer;

        _.forEach(submissionProvideInfoFields, (provideInfoLine) => {
            const nmi_key = provideInfoLine.nmi_choices.key;
            let linePayload = {id: provideInfoLine.id.toString()};

            if (!nmi_key.includes("photos")) {
                if (nmi_key.includes("generic_question")) {
                    linePayload["seller_reply"] = `ANSWER: ${provideInfoData[nmi_key]}`;
                } else if (nmi_key === "hermes_leather_and_size") {
                    if (provideInfoData[nmi_key].toLowerCase().includes("other")) {
                        linePayload["seller_reply"] = provideInfoData[`${nmi_key}_other`];
                    } else {
                        linePayload["seller_reply"] = provideInfoData[nmi_key];
                    }
                } else if (nmi_key === "hermes_general_size") {
                    if (provideInfoData[nmi_key].toLowerCase().includes("other")) {
                        if (provideInfoData[nmi_key].toLowerCase().includes("(cm)")) {
                            linePayload["seller_reply"] = `${provideInfoData[`${nmi_key}_other`]}cm`;
                        } else {
                            linePayload["seller_reply"] = `${provideInfoData[`${nmi_key}_other`]}in`;
                        }
                    } else {
                        linePayload["seller_reply"] = provideInfoData[nmi_key];
                    }
                } else if (nmi_key.includes("general_size") && nmi_key !== "watches_general_size") {
                    linePayload["seller_reply"] = `${provideInfoData[`${nmi_key}_height`]}x${provideInfoData[`${nmi_key}_width`]}x${provideInfoData[`${nmi_key}_depth`]}`;
                    if (nmi_key === "jewelry_general_size") {
                        linePayload["seller_reply"] = `${linePayload["seller_reply"]} - ${provideInfoData[`${nmi_key}_size`]}`;
                    }
                } else {
                    if (nmi_key.includes("international") && provideInfoData[nmi_key] === "no") {
                        refusedReason = "international";
                    } else if (nmi_key.includes("serial") && provideInfoData[nmi_key] === "no") {
                        refusedReason = "Serial Not Available";
                    }
                    linePayload["seller_reply"] = provideInfoData[nmi_key];
                }
                payloadArray.push(linePayload);
            }
        });

        const provideInfoPayload = {
            "evaluationneedsmoreinfo_set": payloadArray,
            "evaluationphoto_set": evaluationphoto_set || []
        };

        dispatch({type: "SHOW_SPINNER"});
        setAxiosInstance(evaluation_id).put(`/nmi/${evaluation_id}/finalize/`, provideInfoPayload)
            .then((response) => {
                if (nextNMIEvaluation) {
                    history.push(`/submissions/provide-information/${zendesk_ticket}/${nextNMIEvaluation.id}`);
                } else {
                    history.push("/submissions/");
                }

                if (refusedReason) {
                    dispatch(sendDeclinedProvideInfo(evaluation_id, zendesk_ticket, nextNMIEvaluation, history, refusedReason));
                }
            })
            .catch((error) => {
                appErrorLogger('Photos: Send NMI Final Evaluation - ' + evaluation_id, error);
            })
            .then((response) => {
                dispatch({type: "HIDE_SPINNER"});
            })
    }
};

const checkLoanStatus = (search_text, callback) => {
    setAxiosInstance().post(`/loan_program/verify_loan/`, {search_text})
      .then((response) => {
          callback(response.data);
      })
      .catch((error) => {
          callback(error.response.data);
      })
}

const createLoan = (search_text, address_id, callback) => {
    setAxiosInstance().post(`/loan_program/create_loan/`, {search_text, address_id})
      .then((response) => {
          callback(response.data);
      })
      .catch((error) => {
          callback(error.response.data);
      })
}

const getLoans = (callback) => {
    setAxiosInstance().get(`/loan_program/loans/`)
      .then((response) => {
          callback(response.data);
      })
      .catch((error) => {
          callback(error.response.data);
      })
}

const getReturnLabel = (loan_id, successCallback, errorCallback) => {
    setAxiosInstance().post(`/loan_program/create_return/`, {loan_id})
      .then((response) => {
          successCallback(response.data);
      })
      .catch((error) => {
          errorCallback(error.response.data);
      })
}

const getConsignments = () => {
    return setAxiosInstance().get(`/consignment/`)
      .then((response) => response.data)
      .catch((error) => {
          appErrorLogger('Get consignments error', error)
          return {
              "sold": [],
              "active": [],
              "inactive": []
          }
      })
}

const getConsignmentHistory = (id) => {
    return setAxiosInstance().get(`/consignment/history/${id}/`)
      .then(response => response.data)
      .catch(error => appErrorLogger('Get consignment item history', error))
}

const getConsignmentDetails = (id) => {
    return setAxiosInstance().get(`/consignment/details/${id}/`)
      .then(response => response.data)
      .catch(error => appErrorLogger('Get consignment item details', error))
}

const payAndFinalizeDelist = (orderItemId, addressId, callback) => {
    return (dispatch, _) => {
        dispatch({type: "SHOW_SPINNER"});
        setAxiosInstance().post(`/consignment/delist/`,
          {
              order_item_id: orderItemId,
              address_id: addressId,
          })
          .then((response) => {
              const {checkout_web_url} = response.data;
              if(checkout_web_url){
                  deleteCookie('is_checkout_finished');
                  setCookie('is_custom_cart', 1);
                  setCookie('delist_checkout', 1, 1);

                  const multipass = new Multipass(config.storefront_api.secret_key);
                  const customerData = {
                      email: getCookie('auth_email'),
                      user: getCookie('auth_token'),
                  };

                  const url = multipass.withCustomerData(customerData)
                    .withDomain(config.storefront_api.domain)
                    .withRedirect(checkout_web_url)
                    .url();
                  callback(null);
                  window.location.href = url;
              } else {
                  callback(response.data);
              }
          })
          .catch((error) => {
              appErrorLogger('Pay And Finalize Delist', error);
              if (error.response) {
                  callback(error.response.data);
              }
          })
          .then(() => {
              dispatch({type: "HIDE_SPINNER"});
          });
    }
};

const offerRevisedAction = (clientResponse, orderItemId, callback) => {
    return ((dispatch) => {
        dispatch({type: "SHOW_SPINNER"});
        setAxiosInstance().put(`/consignment/update-tweak/${orderItemId}/`,
          {
              client_response: clientResponse
        })
          .then(response => {
            dispatch(setConsignments());
            callback(response);
            dispatch({type: "HIDE_SPINNER"});
          })
          .catch(error => {
            appErrorLogger('offer revised', error)
            callback(error);
            dispatch({type: "HIDE_SPINNER"});
          })
    })
}

const setConsignments = () => dispatch => {
    getConsignments().then(consignments => {
        dispatch({
            type: 'SET_CONSIGNMENTS',
            payload: consignments
        })
        return consignments
    })
}


export {
    addToSkuFollowingList,
    removeFromSkuFollowingList,
    getSkuFollowingList,
    getPaymentMethods,
    updateUserProfile,
    setUserProfile,
    deleteAddress,
    editAddress,
    getPurchases,
    getSpecificPurchase,
    getTradeIns,
    setTradeIns,
    getTradeInDetails,
    resetTradeInDetails,
    getMyAccountFavorites,
    getSavedSearches,
    deleteSavedSearch,
    updateSavedSearch,
    getGiftCardsTotal,
    getCreditSummary,
    submitShareFavorites,
    deletePaymentAddressOrAccount,
    getTradeInCartId,
    payAndFinalizeTweak,
    finalizeTweak,
    updateTradeInTweak,
    updateUserPassword,
    sendCouponEmailData,
    sendSmsValidationCode,
    checkSmsValidationCode,
    dismissSmsCheckResultModal,
    updateMarketingFlags,
    getReturnValues,
    doReturn,
    setToggleCancelOrderModal,
    cancelOrder,
    getWalletDetails,
    setWalletPaymentMethods,
    updateAccount,
    setFavoriteBankAccount,
    setFavoriteCheckAddress,
    getPointsTransactionHistory,
    getCashTransactionHistory,
    getCreditTransactionHistory,
    walletCashOut,
    setWalletError,
    getWallet2FAToken,
    sendWallet2FAData,
    setWallet2FAToken,
    setWallet2FAScreenType,
    setWallet2FAError,
    setWallet2FAVerified,
    setWallet2FABlockedFor,
    getSubmissions,
    getSubmissionsDetailed,
    getSubmissionOrderDetails,
    getSubmissionsProvideInfo,
    getSubmissionsProvideInfoHermesLeather,
    getSubmissionsProvideInfoHermesSizes,
    getSubmissionsProvideInfoPhotos,
    sendFinalProvideInfoEvaluation,
    setEvaluationPhotoSet,
    addSavedSearch,
    setWalletAmountToCashOut,
    setAmountToCashModal,
    setAmountToCashLinkPath,
    checkLoanStatus,
    createLoan,
    getLoans,
    getReturnLabel,
    setConsignments,
    getConsignmentHistory,
    getConsignmentDetails,
    payAndFinalizeDelist,
    offerRevisedAction,
}